import axios from "axios";
import { authService, portalService } from "../../configs/constants";

const apiCall = async (method, url, body = {}, headers = {}) => {
  const config: any = {
    method: method,
    url: url,
    data: body,
    headers: headers,
  };

  const { data } = await axios(config);

  return data;
};

const login = async (body) => {
  return await apiCall("POST", `${authService}/login`, body);
};

const getMenuList = async () => {
  return await apiCall("POST", `${portalService}/acl/my-permission`);
  // return {data:{}}
};

const createACLGroups = async (body) => {
  return await apiCall("POST", `${portalService}/acl/group/create`, body);
};

const getACLGroups = async () => {
  return await apiCall("POST", `${portalService}/acl/group/list`, {
    $projection: {
      name: 1,
      menu: 1,
    },
  });
};

const getAllUsers = async (body?: any) => {
  return await apiCall("POST", `${portalService}/user/list`, body);
};

const assignGroupUser = async (body) => {
  return await apiCall("POST", `${portalService}/acl/group/map`, body);
};

const createAccessRequest = async (body) => {
  return await apiCall("POST", `${portalService}/acl/request-permission`, body);
};

const submitHoliday = async (body) => {
  return await apiCall("POST", `${portalService}/roaster/holiday`, body);
};

const getProviderByCompanyCode = async (companyCode) => {
  const headers = {
    "Company-Code": companyCode,
  };
  const body = {
    limit: 40,
    skip: 0,
    companyCode: companyCode,
  };
  return await apiCall(
    "POST",
    `${portalService}/roaster/getProvider`,
    body,
    headers
  );
};

const getCenterByCompanyCode = async (companyCode, category) => {
  const headers = {
    "company-code": companyCode,
  };
  const params = {
    limit: "40",
    skip: "0",
  };
  const body = { companyCode: companyCode };
  const queryString = new URLSearchParams(params).toString();
  return await apiCall(
    "POST",
    `${portalService}/roaster/getProvider/${category}?${queryString}`,
    body,
    headers
  );
};

//Ticketing.........................................

const getTicketCategories = async (body) => {
  return await apiCall("POST", `${portalService}/lov`, body);
};

const getTicketType = async (body) => {
  return await apiCall("POST", `${portalService}/lov`, body);
};

const createIssue = async (body) => {
  return await apiCall("POST", `${portalService}/ticket/ticket`, body);
};

const getTickets = async (filters: any, _id?: any, permissions?: any) => {
  // console.log("🚀 ~ getTickets ~ permissions:", permissions[3], _id);
  let filter = "1=1";
  // :TODO
  // const permission = {
  //   features: ["isAdmin"],
  //   value: "ticketing",
  //   label: "Ticketing Center",
  // };

  // const permission = permissions[3];
  const permission = permissions.find((item) => item.value === "ticketing");

  if (!permission.features.includes("isAdmin")) {
    filter += ` and (user_id = '${_id}' or assignee_id = '${_id}')`;
  }

  for (const key in filters) {
    const element = filters[key];
    if (!element) continue;
    switch (key) {
      case "type":
        filter += ` and type = '${element}'`;
        break;
      case "status":
        filter += ` and status = '${element}'`;
        break;
      case "priority":
        filter += ` and priority = ${element}`;
        break;
      case "title":
        const safeTitle = element.replace(/'/g, "''"); // escape single quotes
        filter += ` and title LIKE '%${safeTitle}%'`;
        break;
    }
  }

  const encodedFilter = encodeURIComponent(filter);
  return await apiCall(
    "GET",
    `${portalService}/ticket/ticket?filter=${encodedFilter}`
  );
};

const getTicketDetail = async (id: string, _id?: any, permissions?: any) => {
  let filter = "";
  const permission = permissions.find((item) => item.value === "ticketing");

  let url = `${portalService}/ticket/ticket/${id}`;

  if (!permission.features.includes("isAdmin")) {
    filter = `(user_id = '${_id}' or assignee_id = '${_id}')`;
    url = `${portalService}/ticket/ticket/${id}?filter=${filter}`;
  }

  return await apiCall("GET", url);
};

const updateTicket = async (id: string, body: any) => {
  return await apiCall("PATCH", `${portalService}/ticket/ticket/${id}`, body);
};

const addComment = async (id: string, body: any) => {
  return await apiCall("POST", `${portalService}/ticket/comment/${id}`, body);
};

export const api = {
  login,
  getAllUsers,
  getMenuList,
  getACLGroups,
  createACLGroups,
  assignGroupUser,
  createAccessRequest,
  getCenterByCompanyCode,
  getProviderByCompanyCode,
  submitHoliday,
  apiCall,
  //...............Ticketing................
  getTicketCategories,
  getTicketType,
  createIssue,
  getTickets,
  getTicketDetail,
  addComment,
  updateTicket,
};
